import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const GpcCategoriesPage = lazy(() => import('~/features/configuration/pages/gpc-categories-page'));

/**
 * GPC Categories — `/configuration/gpc-categories`. Google's published product
 * taxonomy, mirrored verbatim. Access is inherited from the parent `/configuration`
 * route guard (`requirePermission(Screens.CONFIGURATION)`); the page is
 * platform-agnostic reference data, so it ignores the inherited `?platform` param.
 *
 * Surfaces in the sidebar once the matching screen row exists in
 * `/screens/navigation` (seeded in the MSW nav mock, like Lily Taxonomy — neither
 * has a real `screens` row in agentic-identity-service yet).
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/gpc-categories')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <GpcCategoriesPage />
    </Suspense>
  ),
});
